import { formatDate } from 'src/utils/formatters'

export const PENDING = 'Pendente'
export const IN_EXECUTION = 'Em Execução'
export const AWAITING_CLIENT = 'Aguardando Cliente'
export const STEP_STATUS_AWAITING_AGENCY = 'Aguardando Órgão'
export const COMPLETED = 'Concluído'
export const IMPEDED = 'Impedido'
export const ANNOTATION = 'Anotação'
export const CRM_SUSPENDED = 'Inscrição Suspensa'
export const CRM_CANCELED = 'Inscrição Cancelada'
export const CRM_PROVISIONAL = 'Inscrição Provisória'
export const CRM_POSTPONED = 'Postergado'
export const CRM_DEFINITIVE = 'Inscrição Definitiva'
export const DISMISSED = 'Dispensado'
export const NEAR_EXPIRATION = 'Vencimento próximo'
export const EXPIRED = 'Vencido'

const getStepDoctorLabel = (step) => stepsProps[step]?.doctorLabel || stepsProps[step]?.label || step

export const licenseStepsStatusProps = {
  [PENDING]: {
    color: 'yellow-8',
    name: 'schedule',
    description: (step, expirationDate) => `O licenciamento do(a) ${getStepDoctorLabel(step)} será iniciado em breve.`
  },
  [IN_EXECUTION]: {
    color: 'cyan',
    name: 'autorenew',
    description: (step, expirationDate) => `O licenciamento do(a) ${getStepDoctorLabel(step)} foi iniciado.`
  },
  [COMPLETED]: {
    color: 'positive',
    name: 'check',
    description: (step, expirationDate) => `O licenciamento do(a) ${getStepDoctorLabel(step)} está concluído${expirationDate ? ` com data de validade ${formatDate(expirationDate, 'DD/MM/YYYY', 'YYYY-MM-DD')}.` : '.'}`
  },
  [IMPEDED]: {
    color: 'red-6',
    name: 'block',
    description: (step, expirationDate) => `O licenciamento do(a) ${getStepDoctorLabel(step)} foi impedido.`,
    requiredObservation: true
  },
  [ANNOTATION]: {
    color: 'teal-4',
    name: 'drive_file_rename_outline',
    requiredObservation: true
  },
  [AWAITING_CLIENT]: {
    color: 'orange-7',
    name: 'person',
    description: (step, expirationDate) => `O licenciamento do(a) ${getStepDoctorLabel(step)} está aguardando sua resposta para ser continuado.`,
    requiredObservation: true
  },
  [STEP_STATUS_AWAITING_AGENCY]: {
    color: 'blue-7',
    name: 'location_city',
    description: (step, expirationDate) => `O licenciamento do(a) ${getStepDoctorLabel(step)} está aguardando resposta do órgão responsável para ser continuado.`,
    requiredObservation: true
  },
  [CRM_SUSPENDED]: {
    color: 'teal-6',
    name: 'content_paste_off',
    description: 'Sua inscrição do CRM foi suspensa.'
  },
  [CRM_CANCELED]: {
    color: 'red-6',
    name: 'highlight_off',
    description: 'Sua inscrição do CRM foi cancelada.'
  },
  [CRM_PROVISIONAL]: {
    color: 'brown-4',
    name: 'hourglass_empty',
    description: 'Seu CRM foi inscrito provisoriamente.'
  },
  [CRM_POSTPONED]: {
    color: 'purple-4',
    name: 'timer',
    description: (step, expirationDate) => `O licenciamento do(a) ${getStepDoctorLabel(step)} foi postergado.`
  },
  [CRM_DEFINITIVE]: {
    color: 'positive',
    name: 'check',
    description: 'Sua inscrição do CRM foi realizada com sucesso!'
  },
  [DISMISSED]: {
    color: 'indigo-12',
    name: 'playlist_remove',
    description: (step, expirationDate) => `O licenciamento do(a) ${getStepDoctorLabel(step)} é dispensado no seu caso.`
  },
  [NEAR_EXPIRATION]: {
    color: 'orange-8',
    name: 'warning',
    description: (step, expirationDate) => `O licenciamento do(a) ${getStepDoctorLabel(step)} está com vencimento próximo${expirationDate ? ` (${formatDate(expirationDate, 'DD/MM/YYYY', 'YYYY-MM-DD')})` : ''}.`
  },
  [EXPIRED]: {
    color: 'red-8',
    name: 'event_busy',
    description: (step, expirationDate) => `O licenciamento do(a) ${getStepDoctorLabel(step)} está vencido${expirationDate ? ` desde ${formatDate(expirationDate, 'DD/MM/YYYY', 'YYYY-MM-DD')}` : ''}.`
  }
}

export const PREFEITURA = 'city_hall'
export const BOMBEIROS = 'firefighter'
export const VIGILANCIA_SANITARIA = 'health_surveillance'
export const CRM = 'crm'
export const CNES = 'cnes'
export const OUTROS = 'others'

export const steps = [
  PREFEITURA,
  BOMBEIROS,
  VIGILANCIA_SANITARIA,
  CRM,
  CNES,
  OUTROS
]

export const stepsProps = {
  [PREFEITURA]: {
    label: 'Prefeitura',
    doctorLabel: 'Alvará da Prefeitura',
    doctorDescription: 'Documento que autoriza o funcionamento da empresa no município, garantindo que atende às normas urbanísticas e administrativas locais.',
    statusOptions: [PENDING, IN_EXECUTION, AWAITING_CLIENT, STEP_STATUS_AWAITING_AGENCY, COMPLETED, IMPEDED, DISMISSED, CRM_POSTPONED, NEAR_EXPIRATION, EXPIRED]
  },
  [BOMBEIROS]: {
    label: 'Bombeiros',
    doctorLabel: 'Alvará de Bombeiros',
    doctorDescription: 'Certificação que atesta que o estabelecimento cumpre as normas de segurança contra incêndios e pânico, assegurando a proteção de pacientes, funcionários e visitantes.',
    statusOptions: [PENDING, IN_EXECUTION, AWAITING_CLIENT, STEP_STATUS_AWAITING_AGENCY, COMPLETED, IMPEDED, DISMISSED, CRM_POSTPONED, NEAR_EXPIRATION, EXPIRED]
  },
  [VIGILANCIA_SANITARIA]: {
    label: 'Vigilância Sanitária',
    doctorLabel: 'Alvará da Vigilância Sanitária',
    doctorDescription: 'Licença concedida pela vigilância sanitária que comprova que a empresa segue as normas de higiene e biossegurança exigidas para a atividade médica.',
    statusOptions: [PENDING, IN_EXECUTION, AWAITING_CLIENT, STEP_STATUS_AWAITING_AGENCY, COMPLETED, IMPEDED, DISMISSED, CRM_POSTPONED, NEAR_EXPIRATION, EXPIRED]
  },
  [CRM]: {
    label: 'CRM',
    doctorLabel: 'Inscrição no CRM',
    doctorDescription: 'Registro obrigatório para sua empresa perante o Conselho Regional de Medicina.',
    statusOptions: [PENDING, IN_EXECUTION, AWAITING_CLIENT, STEP_STATUS_AWAITING_AGENCY, COMPLETED, IMPEDED, DISMISSED, CRM_POSTPONED, NEAR_EXPIRATION, EXPIRED],
    homeLabel: 'Acesso ao Portal CRM',
    description: 'Para cadastrarmos sua PJ no seu CRM, precisamos do seu acesso ao Portal do CRM.'
  },
  [CNES]: {
    label: 'CNES',
    doctorLabel: 'CNES',
    doctorDescription: 'Registro obrigatório de estabelecimentos de saúde junto ao Ministério da Saúde, essencial para o funcionamento e acesso a serviços públicos e convênios.',
    tooltipLabel: 'Cadastro Nacional de Estabelecimento de Saúde',
    statusOptions: [PENDING, IN_EXECUTION, AWAITING_CLIENT, STEP_STATUS_AWAITING_AGENCY, COMPLETED, DISMISSED, CRM_POSTPONED, IMPEDED, NEAR_EXPIRATION, EXPIRED]
  },
  [OUTROS]: {
    label: 'Outros',
    statusOptions: [PENDING, IN_EXECUTION, COMPLETED, IMPEDED, ANNOTATION, CRM_POSTPONED, DISMISSED, NEAR_EXPIRATION, EXPIRED]
  }
}

export const LICENSE_PENDING = 'Licenciamento Pendente'
export const LICENSE_FINISHED = 'Licenciamento Finalizado'
export const LICENSE_CANCELED = 'Licenciamento Cancelado'

export const LICENSE_STATUS = [LICENSE_PENDING, LICENSE_FINISHED, LICENSE_CANCELED]

export const licenseStatusProps = {
  [LICENSE_PENDING]: { color: 'yellow-8', name: 'schedule' },
  [LICENSE_FINISHED]: { color: 'positive', name: 'check' },
  [LICENSE_CANCELED]: { color: 'red-6', name: 'close' }
}

export const MIN_DATE = 30

export const TYPE_STATUS_CHANGE = 'Alteração de Status'
export const TYPE_STEP_STATUS_CHANGE = 'Alteração de Status de Etapa'
export const TYPE_RESPONSIBLE_CHANGE = 'Alteração de Responsável'
export const TYPE_COMMENT_DELETE = 'Exclusão de Comentário'
export const TYPE_EXPIRATION_DATE_CHANGE = 'Alteração de Data de Validade'
export const TYPE_START_LICENSE = 'Início do Licenciamento'
export const TYPE_CONCLUDED_LICENSE = 'Conclusão do Licenciamento'
export const TYPE_CANCEL_LICENSE = 'Cancelamento do Licenciamento'
export const TYPE_PENDING_LICENSE = 'Retomada do Licenciamento'

export const LICENSE_STATUS_CHANGE = [
  TYPE_START_LICENSE,
  TYPE_STATUS_CHANGE,
  TYPE_CONCLUDED_LICENSE,
  TYPE_CANCEL_LICENSE,
  TYPE_PENDING_LICENSE
]

export const LICENSE_DOCS_TYPES = [
  { name: 'crm_empresa', label: 'CRM', required: true },
  { name: 'alvara_localizacao', label: 'Prefeitura', required: true },
  { name: 'alvara_sanitario', label: 'Vigilância Sanitária', required: true },
  { name: 'alvara_bombeiros', label: 'Alvará dos Bombeiros', required: true },
  { name: 'outros_licenciamento', label: 'Outros documentos de Licenciamento', required: true }
]

export const MAX_COMMENT_FIELD_LENGTH = 1000
export const MAX_DOCTOR_COMMENT_FIELD_LENGTH = 1000
